import React, { useState } from 'react';
import { AppBar, Toolbar, Container, Box, Typography, Button, Stack, Drawer, List, ListItemButton, ListItemText } from '@mui/material';
import { nav } from '../data';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <AppBar position="sticky" elevation={0} sx={{ bgcolor: 'primary.dark', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ minHeight: { xs: 68, md: 80 }, justifyContent: 'space-between', alignItems: 'center' }}>
          <Box
            component="a"
            href="#home"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              bgcolor: '#ffffff',
              borderRadius: '10px',
              px: 1.5,
              py: 0.75,
              my: 'auto',
              boxShadow: '0 2px 12px rgba(0,0,0,0.25)',
              transition: 'box-shadow 0.2s',
              '&:hover': { boxShadow: '0 4px 20px rgba(0,0,0,0.35)' },
            }}
          >
            <Box
              component="img"
              src="/logo.png"
              alt="Shree Bhavani Group of Institutions"
              sx={{ height: { xs: 42, md: 52 }, width: 'auto', objectFit: 'contain', display: 'block' }}
            />
          </Box>

          <Stack direction="row" spacing={3} alignItems="center" sx={{ display: { xs: 'none', md: 'flex' } }}>
            {nav.map(([label, id]) => (
              <Typography key={id} component="a" href={`#${id}`} sx={{ color: 'rgba(255,255,255,0.85)', textDecoration: 'none', fontWeight: 600, fontSize: '0.95rem', '&:hover': { color: 'secondary.main' } }}>
                {label}
              </Typography>
            ))}
            <Button href="#admission" variant="contained" color="secondary" sx={{ py: 1, px: 2.5 }}>Apply now</Button>
          </Stack>

          <Button onClick={() => setOpen(true)} sx={{ display: { xs: 'inline-flex', md: 'none' }, color: '#fff', border: '1px solid rgba(255,255,255,0.4)' }}>
            Menu
          </Button>
        </Toolbar>
      </Container>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)} PaperProps={{ sx: { width: 260, bgcolor: 'primary.dark', color: '#fff' } }}>
        <List sx={{ pt: 4 }}>
          {nav.map(([label, id]) => (
            <ListItemButton key={id} component="a" href={`#${id}`} onClick={() => setOpen(false)}>
              <ListItemText primary={label} primaryTypographyProps={{ fontWeight: 600 }} />
            </ListItemButton>
          ))}
        </List>
        <Box sx={{ px: 2 }}>
          <Button fullWidth href="#admission" variant="contained" color="secondary" onClick={() => setOpen(false)}>Apply now</Button>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
